import { DateTime } from "luxon";

const formatdate = (date: DateTime | null | undefined) => {
  if (!date) {
    return "";
  }
  return date.toFormat("yyyy.MM.dd");
};

export default formatdate;
